import { render, staticRenderFns } from "./TipoLicenciaModalEdicion.vue?vue&type=template&id=4274dca6&scoped=true&"
import script from "./TipoLicenciaModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./TipoLicenciaModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./TipoLicenciaModalEdicion.vue?vue&type=style&index=0&id=4274dca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4274dca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4274dca6', component.options)
    } else {
      api.reload('4274dca6', component.options)
    }
    module.hot.accept("./TipoLicenciaModalEdicion.vue?vue&type=template&id=4274dca6&scoped=true&", function () {
      api.rerender('4274dca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/TipoLicenciaModalEdicion.vue"
export default component.exports